import { controlConfigurations } from '@components/uploadForm/cells/uploadControlConfigurationTester';
import { controlConfigurationCells } from '@components/uploadForm/cells/uploadControlConfigurationCell';
import { uploadFormCreateTester } from '@components/uploadForm/createComponents/uploadFormCreateTester';
import { wrappedControlConfigurationCells } from '@components/uploadForm/createComponents/uploadFormCreateCell';
import { controlConfigurationsTesterRenderer } from '@components/uploadForm/renderers/uploadControlConfigurationTester';
import { uploadControlConfigurationRenderer } from '@components/uploadForm/renderers/uploadControlConfigurationRenderer';
import {
  CellProps,
  JsonFormsCellRendererRegistryEntry,
  JsonFormsRendererRegistryEntry,
  WithClassname,
} from '@jsonforms/core';
import { AdditionalProps } from '@components/uploadForm/Types/ControlConfiguration';
import './index.scss';

/**
 * Custom render cells and renderers for JSON Forms
 * means json form has cells property and renderer property
 * this section only for form CELL and RENDERER property in JSON Forms component
 */

export const combineAntView = () => {
  const cells: JsonFormsCellRendererRegistryEntry[] = controlConfigurationCells
    .map(cell => {
      const matchedConfig = controlConfigurations.find(
        config => config.cell === cell.tester
      );

      if (matchedConfig) {
        return {
          tester: uploadFormCreateTester(matchedConfig),
          cell: wrappedControlConfigurationCells(
            cell.controlWrapperFunc,
            cell.Component as React.FC<
              CellProps & WithClassname & AdditionalProps
            >
          ),
        };
      } else {
        // Handle the case where no matching configuration is found
        console.error(
          `No matching configuration found for tester: ${cell.tester}`
        );
        return null;
      }
    })
    .filter(Boolean) as JsonFormsCellRendererRegistryEntry[];

  const renderers: JsonFormsRendererRegistryEntry[] =
    uploadControlConfigurationRenderer.map(renderer => {
      const matchedConfig = controlConfigurationsTesterRenderer.find(
        config => config.renderer === renderer.tester
      );

      if (matchedConfig) {
        return {
          tester: uploadFormCreateTester(matchedConfig),
          renderer: renderer.component,
        };
      } else {
        // Handle the case where no matching configuration is found
        console.error(
          `No matching configuration found for tester: ${renderer.tester}`
        );
        return undefined;
      }
    }) as JsonFormsRendererRegistryEntry[];

  return {
    cells,
    renderers,
  };
};
